<script lang="ts">
  import type { AccordionItemComponentProps } from './types';
  import { slide } from 'svelte/transition';
  import AccordionPlusMinusPartial from '$components/common/partials/AccordionPlusMinusPartial/AccordionPlusMinusPartial.svelte';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  type $$Props = AccordionItemComponentProps;

  export let entryId: AccordionItemComponentProps['entryId'];
  export let title: AccordionItemComponentProps['title'];
  export let body: AccordionItemComponentProps['body'] = undefined;
  export let customCssClass: AccordionItemComponentProps['customCssClass'];

  let isExpanded = false;
  const handleClick = () => {
    isExpanded = !isExpanded;
  };
  const handleKeyDown = (event: KeyboardEvent) => {
    const { code } = event;
    if (['Space', 'Enter'].includes(code)) {
      event.preventDefault();
      handleClick();
    }
  };
</script>

<li
  class="AccordionItemComponent AccordionItemComponent-{entryId}-box-properties {customCssClass}"
  data-entry-id={entryId}
>
  <div class="gap-none">
    <a href="#" role="button" on:click|preventDefault={handleClick} on:keydown={handleKeyDown}>
      <span class="accordion-title">
        <DynamicChildrenComponent children={title} />
        <AccordionPlusMinusPartial {isExpanded} />
      </span>
    </a>
  </div>
  <div class="gap-none">
    {#if body}
      {#key isExpanded}
        <div class="accordion-body" class:expanded={isExpanded} transition:slide>
          <DynamicChildrenComponent children={body} />
        </div>
      {/key}
    {/if}
  </div>
</li>

<style lang="scss">
  .AccordionItemComponent {
    padding-left: 0;
    padding-top: var(--space-30);
    padding-bottom: var(--space-30);
    border-top: 1px solid var(--color-border-transparent);
  }

  .accordion-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .accordion-body {
    max-width: 70ch;
    visibility: hidden;
    height: 0;

    &.expanded {
      height: auto;
      visibility: visible;
    }

    :global(> :first-child) {
      padding-top: var(--space-10);
    }
  }

  a {
    display: block;
    color: inherit;
    font-weight: inherit;
    text-decoration: none;
  }

  .gap-none {
    margin: var(--space-none);
  }
</style>
